module.exports = __webpack_public_path__ + "static/media/receipt-scan-area.4af53d3a.svg";